var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99678 13.6635C10.6441 13.6635 13.6663 10.647 13.6663 6.9997C13.6663 3.35235 10.6383 0.335938 6.99097 0.335938C3.34681 0.335938 0.333008 3.35235 0.333008 6.9997C0.333008 10.647 3.35261 13.6635 6.99678 13.6635ZM6.99678 12.682C3.85174 12.682 1.32342 10.1505 1.32342 6.9997C1.32342 3.84885 3.84593 1.31735 6.99097 1.31735C10.1418 1.31735 12.6791 3.84885 12.6791 6.9997C12.6791 10.1505 10.1476 12.682 6.99678 12.682ZM5.83239 10.6639H8.52323C8.7635 10.6639 8.95269 10.4895 8.95269 10.246C8.95269 10.0168 8.7635 9.83398 8.52323 9.83398H7.6395V6.30432C7.6395 5.9938 7.47932 5.78778 7.18681 5.78778H5.92729C5.68701 5.78778 5.50363 5.97059 5.50363 6.19664C5.50363 6.43748 5.68701 6.61449 5.92729 6.61449H6.71613V9.83398H5.83239C5.58952 9.83398 5.40293 10.0168 5.40293 10.246C5.40293 10.4895 5.58952 10.6639 5.83239 10.6639ZM6.95033 4.63308C7.39166 4.63308 7.74129 4.28547 7.74129 3.84415C7.74129 3.40281 7.39166 3.05318 6.95033 3.05318C6.51481 3.05318 6.15938 3.40281 6.15938 3.84415C6.15938 4.28547 6.51481 4.63308 6.95033 4.63308Z",
    fill: "#1F2647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ea8f2ae82fff62d42c94ce729f2068ed.svg";
export { ForwardRef as ReactComponent };